import React, { useState } from "react";
import { AppstoreOutlined } from "@ant-design/icons";
import { Button, Tooltip, notification } from "antd";
import { getDeviceApps } from "../../services/devicemanagementservice";
import { AppDto } from "../../types/devicemanagementtypes";
import DeviceAppsDrawer from "./deviceappsdrawer";

interface ViewAppsButtonProps {
    deviceId: string;
    aliasName?: string;
}

const ViewAppsButton: React.FC<ViewAppsButtonProps> = ({ deviceId, aliasName }) => {
    const [drawerVisible, setDrawerVisible] = useState(false);
    const [apps, setApps] = useState<AppDto[]>([]);
    const [appsLoading, setAppsLoading] = useState(false);
    const [appsPagination, setAppsPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
    });
    const [appsSearchTerm, setAppsSearchTerm] = useState("");

    const fetchApps = async (page = 1, pageSize = 10, search?: string) => {
        setAppsLoading(true);
        try {
            const offset = (page - 1) * pageSize;
            const { data } = await getDeviceApps(deviceId, search, pageSize, offset);
            setApps(data.apps);
            setAppsPagination({
                current: page,
                pageSize,
                total: data.totalCount,
            });
        } catch {
            notification.error({
                message: "Error",
                description: "Failed to load apps",
            });
        } finally {
            setAppsLoading(false);
        }
    };

    const openDrawer = () => {
        setDrawerVisible(true);
        setAppsSearchTerm("");
        fetchApps(1, appsPagination.pageSize);
    };

    const closeDrawer = () => {
        setDrawerVisible(false);
        setAppsSearchTerm("");
    };

    return (
        <>
            <Tooltip title="View Apps">
                <Button
                    icon={<AppstoreOutlined style={{ color: "var(--color-primary)" }} />}
                    onClick={openDrawer}
                />
            </Tooltip>

            <DeviceAppsDrawer
                visible={drawerVisible}
                onClose={closeDrawer}
                deviceName={aliasName || deviceId}
                apps={apps}
                loading={appsLoading}
                pagination={appsPagination}
                onPageChange={(page, pageSize) => {
                    fetchApps(page, pageSize, appsSearchTerm);
                }}
                onSearch={(value) => {
                    setAppsSearchTerm(value);
                    fetchApps(1, appsPagination.pageSize, value);
                }}
                searchValue={appsSearchTerm}
            />
        </>
    );
};

export default ViewAppsButton;